import { refreshAccessToken } from "@/service/authService";
import { getAccessToken } from "./tokenService";
let timeoutId = null;

export function pararTimer() {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
}

export function iniciarTimerRenovacaoToken() {
  pararTimer();

  const token = getAccessToken();
  if (!token) return;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp;
    const agora = Math.floor(Date.now() / 1000);
    const margemSeguranca = 60; // 1 minuto antes de expirar

    const tempoRestanteMs = (exp - agora - margemSeguranca) * 1000;

    if (tempoRestanteMs <= 0) {
      // Se já passou da margem, tenta renovar agora
      executarRenovacao();
    } else {
      // Agenda para UMA execução
      timeoutId = setTimeout(executarRenovacao, tempoRestanteMs);
    }
  } catch (e) {
    console.error("Erro ao decodificar token", e);
  }
}

async function executarRenovacao() {
  try {
    await refreshAccessToken();
    // Após renovar com sucesso, agenda a PRÓXIMA renovação
    iniciarTimerRenovacaoToken();
  } catch (error) {
    console.error("Falha na renovação automática");
    pararTimer();
  }
}
